import Button from '@components/Button';
import TextField from '@components/TextField';
import Table from '@components/Table';
import Select from '@components/Select';
import Icon from '@material-ui/core/Icon';
import { apiClient } from '@services/api';
import { useHistory } from "react-router-dom";
import { useState, useEffect } from 'react';
import BreadCrumbs from '@components/Breadcrumbs';
import StatusSwitch from '@components/StatusSwitch';

const permissions = ['administrador'];

const Index = (props) => {
  document.title = `Lista de passeios - ${process.env.REACT_APP_NAME}`
  const history = useHistory();
  let [rows] = useState([]);
  let [q, setQ] = useState("");
  let [region, setRegion] = useState("all");
  let [regionsData, setRegionsData] = useState([]);
  let [downloadingCostsPdf, setDownloadingCostsPdf] = useState(false);
  let url = '/regions';

  // PDF pedido pelo Marcelo (2026-08-19): lista todos os passeios privados
  // com as faixas de preço/custo operacional cadastradas, pra conferência
  // do que está no cadastro depois do fix do bug de custo operacional
  // multiplicado por pessoa em passeio privado.
  const downloadPrivateCostsPdf = () => {
    setDownloadingCostsPdf(true)
    apiClient.httpInstance.get('/tours/private_tours_costs_pdf', {
      responseType: 'blob',
    }).then(response => {
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = `passeios-privados-custos-operacionais-${new Date().toISOString().slice(0, 10)}.pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(blobUrl)
      setDownloadingCostsPdf(false)
    }).catch(() => {
      setDownloadingCostsPdf(false)
      alert('Falha ao gerar o PDF. Tente novamente em instantes.')
    })
  }

  const bradecrumbsConfig = [
    {
      title: 'Início',
    }
  ]

  const getRegionData = url => {
    apiClient.httpInstance.get(url).then(response => {
      if (response.status === 200) {
        let regions = response.data.sort(function (a, b) {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        })
        
        setRegionsData(regions);
      }
    });
  }

  const getRegionById = id => {
    return apiClient
    .httpInstance.get(`/regions/${id}`)
    .then(response => {
      if (response.status === 200 || response.status === 201) {
        return response.data.name
      }
    })
    .catch(error => {
      if(error) {
        return 'Sem região'
      }
    });
  }

  const getArrayWithRegionName = async (array) => {
    const value = array.map(async (obj) => {
      return {
        ...obj,
         regionName: !Number(obj.region) ? obj.region : await getRegionById(obj.region)
       }
     })
     return Promise.all(value)
  }

  const getTours = (path, page, pageSize, params) => {
    return apiClient.httpInstance.get(path, {
      params: {
        ...params,
        pageSize,
        page
      }
    }).then(async response => {
      if (response.status === 200) {
        const value = await getArrayWithRegionName(response.data.data)
        response.data.data = value
        return response.data;
      }
    });
  }

  useEffect(() => {
    getRegionData(url);
  }, [url]);

  //Oculta menu lateral
  useEffect(() => {
    props.setShowMenu(false)
  }, []);

  return <>
    <div className="px-4 md:px-7">
      <div className="flex flex-wrap items-center justify-between mt-2 text-2xl text-blue mb-3 gap-2">
        <div className="flex items-center">
          <Icon className="mr-2">
            photo_camera
          </Icon>
          <span>Lista de passeios</span>
        </div>
        <div className="flex items-center gap-2">
          {permissions.includes(props?.theme?.permission) && <Button
            textcolor="#fff"
            padding="6px 15px"
            margintop="0px"
            width="230"
            disabled={downloadingCostsPdf}
            onClick={downloadPrivateCostsPdf}
            customcolor="#5b6b7f"><Icon className="mr-2">picture_as_pdf</Icon> {downloadingCostsPdf ? 'Gerando...' : 'PDF custos privados'}</Button>}
          {permissions.includes(props?.theme?.permission) && <Button
            textcolor="#fff"
            padding="6px 15px"
            margintop="0px"
            width="200"
            onClick={() => history.push('passeios/cadastro')}
            customcolor={props.theme.color}><Icon className="mr-2">add</Icon> Novo</Button>}
        </div>
      </div>
      <div className="p-4 mt-4 bg-white border-1" style={{borderRadius: '10px 10px 0px 0px'}}>
        <div className="flex flex-col md:flex-row flex-wrap items-stretch md:items-center gap-3">
          <div className="flex-1" style={{ minWidth: '200px' }}>
            <TextField
              className="inputRounded"
              label="Busque pelo nome do passeio"
              variant="outlined"
              type="text"
              name="q"
              onChange={(e) => setQ(e.target.value)}
              required></TextField>
          </div>
          <div style={{ minWidth: '180px' }}>
            <Select
              label="Regiões"
              defaultValue="all"
              onChange={(e) => setRegion(e.target.value)}
              items={{
                field: {
                  value: 'id',
                  text: 'name'
                },
                data: regionsData
              }}
            ></Select>
          </div>
        </div>
      </div>
      <Table
        path="/tours"
        //loadRows={getTours}
        params={{
          q, region
        }}
        columns={[
            {
              headerName: 'Passeio',
              headerClassName: 'super-app-theme--header',
              field: 'name',
              flex: 1,
              renderCell: (params) => {
                const row = params.row;
                return (
                  <div className="flex items-center">
                    <span>{row.name}</span>
                  </div>
                )
              },
            },
            {
              headerName: 'Região',
              headerClassName: 'super-app-theme--header',
              field: 'regionName',
              flex: 0.5,
              renderCell: (params) => {
                const row = params.row
                return (
                  <div className="flex items-center">
                    {row.region_name}
                  </div>
                )
              }
            },
            {
              headerName: 'Período do dia',
              headerClassName: 'super-app-theme--header',
              field: 'day_period',
              flex: 0.5,
              renderCell: (params) => {
                const row = params.row;
                return (
                  <div className="flex items-center">
                    {row.tour_period === 'fullday' ?
                      'Integral'
                    :
                      row.day_period === "PM" ? 'Depois do meio-dia ' : 'Antes do meio-dia'
                    }
                  </div>
                )
              },
            },
            {
              headerName: 'Status',
              headerClassName: 'super-app-theme--header',
              field: 'status',
              headerAlign: 'right',
              align: 'right',
              flex: 0.5,
              preventRedirect: true,
              renderCell: (params) => {
                const row = params.row;

                return (
                  <div className="flex items-center pr-4 space-x-5">
                    {permissions.includes(props?.theme?.permission) ?
                    <StatusSwitch status={row.status} url={`/tours/${row.id}/status`} />
                    :
                    <>{row.status ? 'Ativo' : 'Inativo'}</>
              }
                  </div>
                );
              }
            }
          ]}
        rows={rows}
      />
    </div>
  </>
}

export default Index;